import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";
import { UserRole } from "@employee-management/common";
import { Wrench } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeading } from "@/components/ui/page-heading";
import { DepartmentsTab } from "./DepartmentsTab";
import { ProjectInternalMembersTab } from "./ProjectInternalMembersTab";
import { MaintenanceTab } from "./MaintenanceTab";

export function AppSettingsView() {
  const [activeTab, setActiveTab] = useState("departments");
  const { hasRole } = useAuth();

  return (
    <div className="container mx-auto py-6 space-y-6">
      <PageHeading
        title="App Settings"
        subtitle="Manage application-wide settings and configurations."
        actions={
          hasRole(UserRole.SUPERADMIN) ? (
            <Button
              onClick={() => setActiveTab("maintenance")}
              variant="outline"
            >
              <Wrench className="h-4 w-4" />
              Maintenance
            </Button>
          ) : undefined
        }
      />

      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="space-y-6"
      >
        <TabsList className="grid w-full grid-cols-1 lg:grid-cols-3">
          <TabsTrigger value="departments">Departments</TabsTrigger>
          <TabsTrigger value="internal-members">
            Project Internal Members
          </TabsTrigger>
          {hasRole(UserRole.SUPERADMIN) && (
            <TabsTrigger value="maintenance">Maintenance</TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="departments" className="space-y-6">
          <DepartmentsTab />
        </TabsContent>

        <TabsContent value="internal-members" className="space-y-6">
          <ProjectInternalMembersTab />
        </TabsContent>

        {hasRole(UserRole.SUPERADMIN) && (
          <TabsContent value="maintenance" className="space-y-6">
            <MaintenanceTab />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
